export default "__VITE_ASSET__CTqpSeP3__"